import type { AppEvent } from '$lib/helper/appEvents';
import { apiStore } from '$lib/stores/api';
import type { UserNotificationSettingsGetApiResponse } from '$lib/types/api/notificationSettings';
import type { Axios } from 'axios';
import { get, writable } from 'svelte/store';

type EventSetting = {
	notifyApp: boolean;
	notifyPushDesktop: boolean;
	notifyPushMobile: boolean;
	notifyEmail: boolean;
	sound: string;
	capabilities: {
		app: boolean;
		push: boolean;
		email: boolean;
	};
};

type NotificationSettingStore = {
	[event: string]: EventSetting;
};

const storeDefinition = () => {
	const { subscribe, set, update } = writable<NotificationSettingStore>({});

	return {
		subscribe,
		set,
		update,
		refresh: () => {
			(get(apiStore) as Axios)
				.get<UserNotificationSettingsGetApiResponse>('/notification-settings')
				.then((settings) => {
					notificationSettingStore.set(settings.data);
				});
		},
		refreshFromData: (data: UserNotificationSettingsGetApiResponse) => {
			notificationSettingStore.set(data);
		},
		flip: (event: string, setting: keyof Omit<EventSetting, 'sound' | 'capabilities'>) => {
			update((settings) => {
				settings[event][setting] = !settings[event][setting];

				(get(apiStore) as Axios).post('/notification-settings', {
					event: event,
					...settings[event]
				});

				return settings;
			});
		},
		setSound: (event: string, sound: string) => {
			update((settings) => {
				settings[event].sound = sound;

				(get(apiStore) as Axios).post('/notification-settings', {
					event: event,
					...settings[event]
				});

				return settings;
			});
		},
		getSound: (event: string) => {
			return get(notificationSettingStore)[event].sound;
		},
		getAllEvents: (): AppEvent[] => {
			return Object.keys(get(notificationSettingStore)) as AppEvent[];
		}
	};
};

export const notificationSettingStore = storeDefinition();
